import api from 'plugin/api';
import { API_URL } from 'types/const';

/**
 * 배합비 생산량 목록 조회
 * @param {Object} [params] 요청 데이터
 * @param {number[]} [params.factoryCodeSeqList] 선택한 공장
 * @param {string} [params.prodYm] 월
 * @param {string} [params.mixCd] 배합비 코드
 * @return {Object} 응답 데이터
 */
async function requestList(params) {
  return api.get(API_URL.sfms.mix.output.list, { params });
}

/**
 * 배합비 생산량 BestMix에 전송
 * @param {Object} data 요청 데이터
 * @param {number} data.factoryCodeSeq 공장
 * @param {string} data.prodYm 월
 * @return {Object} 응답 데이터
 */
async function requestExport(data) {
  return api.post(API_URL.sfms.mix.output.export, data);
}

export { requestList, requestExport };
